import React, { FC, useState }         from "react";
import { useDispatch }                 from "react-redux";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import DeleteRecordTemplate            from "../../../../application/usecase/record/template/DeleteRecordTemplate";
import RecordTemplate                  from "../../../../domain/record/template/RecordTemplate";

interface Props {
  recordTemplate: RecordTemplate;
}

const RecordTemplateDeleteButton: FC<Props> = (props: Props) => {
  const [open, setOpen] = useState(false);
  const {recordTemplate} = props;
  const deleteRecordTemplate: DeleteRecordTemplate = new DeleteRecordTemplate(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        negative
        onClick={ () => setOpen(true) }
      >
        <Icon name="trash"/>
        削除する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>記録テンプレート削除の確認</Modal.Header>
        <Modal.Content>
          <Header as="h5" icon="info circle" dividing content={ `${ recordTemplate.name.value }を削除します。` } color="red"/>
          <Modal.Description>
            <p>よろしいですか？</p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
          <Button
            icon
            labelPosition="left"
            negative
            onClick={ () => {
              deleteRecordTemplate.execute(recordTemplate.id);
              setOpen(false);
            } }
          >
            <Icon name="trash"/>
            削除する
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default RecordTemplateDeleteButton;
